import { InspectionWorkflow, InspectionQuestion, WorkflowStep, IterateStep } from "../types/inspectionWorkflow";

export interface Checkpoint {
  question_id: string;
  text: string;
  mode: string;
}

/** Flatten all workflow steps, unwrapping iterate sub-steps */
const flattenAndGetAllSteps = (workflow: InspectionWorkflow): WorkflowStep[] =>
  workflow.categories.flatMap((category) =>
    category.steps.flatMap((step): WorkflowStep[] =>
      "iterate" in step ? (step as IterateStep).iterate : [step as WorkflowStep]
    )
  );

/** Extract question IDs from a single step */
const getQuestionIdsFromStep = (step: WorkflowStep): string[] => [
  ...("question_id" in step && step.question_id ? [step.question_id] : []),
  ...("backend" in step && step.backend?.question_ids ? step.backend.question_ids : []),
];

/**
 * Extracts all question IDs referenced in workflow steps, then maps them
 * to their corresponding question text and mode from the questions list.
 */
export const getCheckpoints = (
  workflow: InspectionWorkflow,
  questions: InspectionQuestion[]
): Checkpoint[] => {
  const questionMap = new Map(questions.map((q) => [q.id, q]));
  const questionIdsInWorkflow = flattenAndGetAllSteps(workflow).flatMap(getQuestionIdsFromStep);

  return [...new Set<string>(questionIdsInWorkflow)]
    .map((id) => questionMap.get(id))
    .filter((q): q is InspectionQuestion => !!q)
    .map((q) => ({ question_id: q.id, text: q.text, mode: q.mode }));
};
